import React from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  PauseCircleFilledOutlined,
  PlayCircleFilledOutlined,
  BackspaceOutlined,
} from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import { useStoreByName } from '@web/hooks/use-stores.hooks';
import CleanBoardIcon from '../../../assets/SVGComponents/iconCleanBoard';

const ActionButtons = () => {
  const { t } = useTranslation();
  const speechRecognitionStore = useStoreByName('speechRecognitionStore') as any;
  const readingSessionStore = useStoreByName('readingSessionStore') as any;
  
  const {
    isDone,
    isStarted,
    isPaused,
    currentSpokenText,
    toggleListening,
    removeLastWord,
    removeAllText,
  } = speechRecognitionStore;

  // בדיקה אם יש מילים שכבר נקראו - כלומר יש מה למחוק
  // הכפתורים צריכים להיות פעילים רק אם:
  // 1. יש טקסט שנאמר (currentSpokenText)
  // 2. או אם יש מילים שכבר נקראו (currentWordIndex > 0)
  const readingSession = readingSessionStore?.readingSession;
  const hasWordsToDelete = 
    currentSpokenText || // יש טקסט שנאמר
    (readingSession && readingSession.currentWordIndex > 0); // יש מילים שכבר נקראו (לא במילה הראשונה)

  // פונקציות פשוטות שקוראות ישירות ל-speechRecognitionStore
  const handleRemoveLastWord = () => {
    removeLastWord();
  };

  const handleRemoveAllText = () => {
    removeAllText();
  };

  return (
    <div className="action-buttons">
    </div>
  );
};

export default observer(ActionButtons);
